// Shared bits between the promo card add and edit forms.
export const PLACEMENT_OPTIONS = [
  { value: 'home', text: 'Home' },
  { value: 'fixture', text: 'Fixture' },
  { value: 'rank', text: 'Rank' },
  { value: 'members', text: 'Members' },
  { value: 'rivals', text: 'Rivals' },
]

const isValidDate = (date) => date instanceof Date && !Number.isNaN(date.getTime())

// Turns a stored API date into the "YYYY-MM-DD" a native date input takes. Blank dates
// used to be saved as the string "null" (FormData stringifies null), and some come back
// with a time part, so anything that isn't a real date becomes ''.
export const toPickerDate = (value) => {
  if (!value || typeof value !== 'string' || value.startsWith('0000-00-00')) return ''
  return isValidDate(new Date(value)) ? value.slice(0, 10) : ''
}
